// Postgres DATE deveria chegar como string 'YYYY-MM-DD' (configuramos o pg
// driver no backend pra isso). Se chegar como 'YYYY-MM-DDT00:00:00.000Z' (Date
// object serializado por backend antigo), o JS interpretaria como meia-noite
// UTC e em BRT (UTC-3) viraria 21h do dia anterior — UI mostrando 1 dia a
// menos.
//
// parseDate aceita os dois formatos e retorna um Date no meio-dia LOCAL, o que
// é seguro pra renderizar com `format(...)` em qualquer fuso.
export function parseDate(s) {
  if (!s) return null;
  if (s instanceof Date) return s;
  if (typeof s === 'string') {
    // Pega só os 10 primeiros caracteres se vier no formato ISO completo
    const ymd = s.slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
      return new Date(`${ymd}T12:00:00`);
    }
  }
  return new Date(s);
}

// Formata data ou período compactamente:
//   formatPeriodo('2026-10-25')                          → '25/10/2026'
//   formatPeriodo('2026-10-25', '2026-10-28')            → '25 a 28/10/2026'
//   formatPeriodo('2026-10-30', '2026-11-02')            → '30/10 a 02/11/2026'
//   formatPeriodo('2026-12-30', '2027-01-02')            → '30/12/2026 a 02/01/2027'
// short=true usa formato curto (sem ano): '25/10' / '25 a 28/10'.
export function formatPeriodo(inicio, fim, { short = false } = {}) {
  const di = parseDate(inicio);
  const df = parseDate(fim);
  if (!di) return '';
  const padDM = (d) => `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
  const padDMY = (d) => `${padDM(d)}/${d.getFullYear()}`;
  if (!df || df.getTime() === di.getTime()) {
    return short ? padDM(di) : padDMY(di);
  }
  const mesmoMesAno = di.getMonth() === df.getMonth() && di.getFullYear() === df.getFullYear();
  const mesmoAno = di.getFullYear() === df.getFullYear();
  if (mesmoMesAno) {
    return short
      ? `${String(di.getDate()).padStart(2, '0')} a ${padDM(df)}`
      : `${String(di.getDate()).padStart(2, '0')} a ${padDMY(df)}`;
  }
  if (mesmoAno) {
    return short
      ? `${padDM(di)} a ${padDM(df)}`
      : `${padDM(di)} a ${padDMY(df)}`;
  }
  return `${padDMY(di)} a ${padDMY(df)}`;
}

// Texto de duração ("3 dias", "1 semana"). null = ação de 1 dia.
export function duracaoTexto(inicio, fim) {
  const di = parseDate(inicio);
  const df = parseDate(fim);
  if (!di || !df) return null;
  const dias = Math.round((df - di) / (1000 * 60 * 60 * 24)) + 1;
  if (dias <= 1) return null;
  if (dias === 7) return '1 semana';
  if (dias % 7 === 0) return `${dias / 7} semanas`;
  return `${dias} dias`;
}

// True se a ação está ATIVA hoje (entre data_acao e data_acao_fim inclusivos).
export function acaoAcontecendoAgora(inicio, fim) {
  const di = parseDate(inicio);
  if (!di) return false;
  const df = parseDate(fim) || di;
  const hoje = new Date();
  hoje.setHours(12, 0, 0, 0); // meio-dia local pra comparar com parseDate
  return hoje >= di && hoje <= df;
}
